import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import app from './app'
import beneficiaryForm from './beneficiaryForm'
import bankTransferForm from './bankTransferForm'
import beneficiaries from './beneficiaries'
import beneficiaryUpload from './beneficiaryUpload'
import hierarchyUpload from './hierarchyUpload'
import partnerHierarchy from './partnerHierarchy'
import partnerPlans from './partnerPlans'
import partnerPlan from './partnerPlan'
import partnerPlanAdmin from './partnerPlanAdmin'
import partnerPlanForm from './partnerPlanForm'
import partnerPlanRatingsUpload from './partnerPlanRatingsUpload'
import partnerPlanReminderNotification from './partnerPlanReminderNotification'
import partnerChildrenForm from './partnerChildrenForm'
import accountsAndLoans from './accountsAndLoans'
import personalInfo from './personalInfo'
import personalinfos from './personalInfos'
import forms from './forms'
import managePermissions from './managePermissions'
import mdm from './mdm'
import modals from './modals'
import documents from './documents'
import uploadLogs from './uploadlogs'
import reports from './reports'
import templateUpload from './templateUpload'
import partnerPlanRatingVisibility from './partnerPlanRatingVisibility'
import featureToggle from './featureToggle'

const rootReducer = combineReducers({
  app,
  personalInfo,
  documents,
  accountsAndLoans,
  bankTransferForm,
  beneficiaries,
  beneficiaryForm,
  beneficiaryUpload,
  hierarchyUpload,
  managePermissions,
  mdm,
  personalinfos,
  partnerHierarchy,
  partnerPlans,
  partnerPlan,
  partnerPlanAdmin,
  partnerPlanForm,
  partnerPlanRatingsUpload,
  partnerPlanRatingVisibility,
  featureToggle,
  partnerPlanReminderNotification,
  partnerChildrenForm,
  templateUpload,
  uploadLogs,
  forms,
  modals,
  reports,
  router: routerReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js